import React, { useState } from 'react'
import { MobileCheckOutNewAddress } from '../components/Mobile/MobilePages/MobileCheckout/MobileCheckOutNewAddress'
import withCheckoutForm from '../components/Desktop/Pages/ChecoutPage/HOCs/withCheckoutForm'

const Location = ({
	formData,
	handleInputChange,
	handleSubmit,
	countriesList,
	statesList,
	districtList,
	userShippingAddress,
	errors,
	isFormValid,
}) => {
	const [isCollapsed, setIsCollapsed] = useState(true)
	const handleNewSubmit = async (e) => {
		handleSubmit(e)
		setIsCollapsed(!isCollapsed)
	}

	const toggleCollapse = () => {
		setIsCollapsed(!isCollapsed)
	}
	return (
		<div>
			{/* <div class='input-group input-group-outline align-items-center'>
				<input type='text' class='form-control w-90' placeholder='Try JP Nagar, Andheri West etc....' />
				<span class='input-group-text end-3 position-absolute opacity-5'>
					<img src='../../assets/img/svg/search.svg' height='20' alt='' />
				</span>
			</div> */}
			<div className='container-fluid'>
				{/* <div className='d-flex mt-3'>
					<div>
						<a href=''>
							<h6 className='text-warning text-normal'>
								<i class='bi bi-send-fill  me-2'></i>
								Use my current location
							</h6>
						</a>
					</div>
				</div>
				<hr class='horizontal dark mt-2' /> */}
				{/* <div className='d-flex mt-2'>
					<div>
						<a href=''>
							<h6 className='text-warning text-normal'>
								<i class='ri-add-fill fa-lg me-2'></i>
								Add new address
							</h6>
						</a>
					</div>
				</div> */}
				<div className='accordion' id='accordionPay'>
					<div className='accordion-item mb-0'>
						<h5 className='accordion-header' id='headingNewAddress'>
							<button
								className='accordion-button font-weight-bold'
								type='button'
								onClick={toggleCollapse}
								aria-expanded={!isCollapsed}
								aria-controls='collapseNewAddress'
							>
								<h6 className='text-warning text-normal'>
									<i class='ri-add-fill fa-lg me-2'></i>
									Add new address
								</h6>
								{/* <small className='text-sm pt-1 position-absolute end-0 me-3'>{isCollapsed ? 'View' : 'Hide'}</small> */}
							</button>
						</h5>
						<div
							id='collapseNewAddress'
							className={`accordion-collapse collapse ${!isCollapsed ? 'show' : ''}`}
							aria-labelledby='headingNewAddress'
							data-bs-parent='#accordionPay'
						>
							<MobileCheckOutNewAddress
								formData={formData}
								handleInputChange={handleInputChange}
								countriesList={countriesList}
								statesList={statesList}
								districtList={districtList}
								errors={errors}
							/>
							<div>
								<button
									className='btn btn-dark w-100 mb-5 btn-lg text-capitalize'
									onClick={(e) => handleNewSubmit(e)}
									disabled={!isFormValid()}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
				<hr class='horizontal dark mt-3' />
				<div className='d-flex mt-2 fs-6'>
					<p>SAVED ADDRESSES</p>
				</div>

				{userShippingAddress?.map((address, index) => (
					<>
						<div className='d-flex mt-2 form-check p-0' key={address._id}>
							<div className='mt-1'>
								<a>
									<i class='ri-map-pin-fill fa-2x text-warning'></i>
								</a>
							</div>
							{/* <div className='mt-2 pt-1 ms-3 lh-1'>
								<input
									className='form-check-input'
									type='radio'
									id={`addressCheck${index}`}
									name='selectedAddress'
									value={address._id}
									checked={formData.selectedAddress === address._id}
									style={{ flexShrink: 0 }}
									onChange={handleInputChange}
								/>
							</div> */}
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-around',
								}}
							>
								<div className='mt-2 pt-1 ms-3 lh-1'>
									<a href='#'>
										<b>{address.city}</b>
									</a>
									<br />
									<sub className='custom-control-label text-xxs' htmlFor={`addressCheck${index}`} style={{ flexGrow: 1 }}>
										{`
       ${address.addressLine1}, ${address.addressLine2}, ${address.landmark ? `${address.landmark}, ` : ''}${address.zipCode}, ${address.city}, ${
											address.stateId?.name
										}, phone number - ${address.mobileNo}`}
									</sub>
								</div>
								<div className='col justify-content-end text-end mt-3'>
									<a
										href='#'
										onClick={async (e) => {
											e.preventDefault()

											// Combine the full address into a single string
											const fullAddress = `
          ${address.addressLine1}, ${address.addressLine2}, ${address.landmark ? `${address.landmark}, ` : ''}${address.zipCode}, ${address.city}, ${
												address.stateId?.name
											}, phone number - ${address.mobileNo}`

											try {
												// Copy the address to the clipboard
												await navigator.clipboard.writeText(fullAddress)

												// Open the share popup
												if (navigator.share) {
													await navigator.share({
														title: 'Address Details',
														text: `Here is the address:\n${fullAddress}\n\nShared from: `,
														url: window.location.href, // Current page URL
													})
												} else {
													alert('Web Share API not supported in this browser.')
												}
											} catch (err) {
												console.error('Failed to copy address or share:', err)
												alert('Could not copy or share the address. Please try again.')
											}
										}}
									>
										<span id='basic-addon1'>
											<i className='bi bi-share'></i>
										</span>
									</a>
								</div>
							</div>
						</div>
					</>
				))}

				{/* <div className='d-flex mt-2'>
					<div className='mt-1'>
						<a>
							<i class='bi bi-person-workspace fa-2x text-warning'></i>
						</a>
					</div>
					<div class=' mt-2 pt-1 ms-3 lh-1'>
						<a href=''>
							<b>Work . 7.6km</b>
						</a>
						<br />
						<sub className='text-xxs'>5-12-s1-25 Second Floor, 6-3-1801, Manchala Street</sub>
					</div>
					<div className='col justify-content-end text-end mt-3'>
						<a href=''>
							<span id='basic-addon1'>
								<i class='bi bi-share '></i>
							</span>
						</a>
					</div>
				</div> */}
				{/* <hr className='horizontal dark mt-2' /> */}
			</div>
		</div>
	)
}

export default withCheckoutForm(Location)
